"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "schivenoglia": {
    "3bce072c": [{
      "hkey": "6b9a816a",
      "slug": "schivenoglia",
      "name": "Schivenoglia",
      "primary": true,
      "skipSearch": false
    }],
    "brazzuolo": [{
      "hkey": "6b9a816a",
      "slug": "schivenoglia",
      "name": "Schivenoglia",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "c2c5ca47": [{
      "hkey": "6b9a816a",
      "slug": "schivenoglia",
      "name": "Schivenoglia",
      "primary": true,
      "skipSearch": false
    }],
    "caselle": [{
      "hkey": "6b9a816a",
      "slug": "schivenoglia",
      "name": "Schivenoglia",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "62de0062": [{
      "hkey": "6b9a816a",
      "slug": "schivenoglia",
      "name": "Schivenoglia",
      "primary": true,
      "skipSearch": false
    }],
    "gabbianella": [{
      "hkey": "6b9a816a",
      "slug": "schivenoglia",
      "name": "Schivenoglia",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "b49ac268": [{
      "hkey": "6b9a816a",
      "slug": "schivenoglia",
      "name": "Schivenoglia",
      "primary": true,
      "skipSearch": false
    }],
    "malpasso": [{
      "hkey": "6b9a816a",
      "slug": "schivenoglia",
      "name": "Schivenoglia",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;